<script>export let component;
let instance;
let initialized = false;
$: if (component?.listeners && instance && !initialized) {
  Object.keys(component.listeners).forEach((key) => {
    instance.$on(key, component.listeners[key]);
  });
  initialized = true;
}
</script>

{#if component}
	<svelte:component
		this={component.component}
		bind:this={instance}
		{...component.props}
		{...$$restProps}
	/>
{/if}